(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sb-categories"] && !window.DesignMode) return;
  try {
    
  const carousel = document.getElementById('custom-carousel');
  const arrowLeft = document.querySelector('.custom-carousel-arrow-left');
  const arrowRight = document.querySelector('.custom-carousel-arrow-right');
  let isDragging = false, startX, scrollLeft;

  // Drag scroll functionality
  carousel.addEventListener('mousedown', (e) => {
    isDragging = true;
    carousel.classList.add('custom-carousel-dragging');
    startX = e.pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
  });

  carousel.addEventListener('mouseleave', () => {
    isDragging = false;
    carousel.classList.remove('custom-carousel-dragging');
  });

  carousel.addEventListener('mouseup', () => {
    isDragging = false;
    carousel.classList.remove('custom-carousel-dragging');
  });

  carousel.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carousel.offsetLeft;
    const walk = (x - startX) * 2; // Adjust scroll speed
    carousel.scrollLeft = scrollLeft - walk;
  });

  // Mobile touch support
  carousel.addEventListener('touchstart', (e) => {
    isDragging = true;
    carousel.classList.add('custom-carousel-dragging');
    startX = e.touches[0].pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
  });

  carousel.addEventListener('touchend', () => {
    isDragging = false;
    carousel.classList.remove('custom-carousel-dragging');
  });

  carousel.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - carousel.offsetLeft;
    const walk = (x - startX) * 2;
    carousel.scrollLeft = scrollLeft - walk;
  });

  // Arrow navigation
  arrowLeft.addEventListener('click', () => {
    carousel.scrollBy({ left: -carousel.offsetWidth / 3, behavior: 'smooth' });
  });

  arrowRight.addEventListener('click', () => {
    carousel.scrollBy({ left: carousel.offsetWidth / 3, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
